export const ORG_FAQ_ORDER = [
  'howToCreateEvent',
  'howToJoinAffiliateProgram',
  'howToGetInvoice',
  'invoices',
  'earnings',
  'affiliate',
] as const

export type OrgFaqKey = (typeof ORG_FAQ_ORDER)[number]
